<template>
	<div class="mainBox">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" title="工作台" 
				left-text="返回" 
				left-arrow 
				@click-left="goBack">
			</van-nav-bar>
		</div>
		<div class="projectItem">
			<div class="itemRow">
				<div class="label">工作控制号</div>
				<div class="value">{{this.project.workNo}}</div>
			</div>
			<div class="itemRow">
				<div class="label">项目名称</div>
				<div class="value">{{this.project.projectName}}</div>
			</div>
			<div class="itemRow">
				<div class="label">委托方</div>
				<div class="value">{{this.project.projectEntrust}}</div>
			</div>
		</div>
		<div class="projectItem">
			<div class="itemTitle2 isBgOrange2">工作台</div>
			<van-row class="workList" gutter="20">
				<van-col span="8">
					<van-badge @badge-size="20">
						<a class="workItem isBgOrange" @click="goPhoto()" href="#">照片</a>
					</van-badge>
				</van-col>
				<van-col span="8">
				</van-col>
				<van-col span="8">
				</van-col>
			</van-row>
		</div>
	</div>
</template>

<script>
	import common from '../utils/common';
	import { Notify } from 'vant';
	export default {
		name: 'workbench',
		data() {
			return {
				project: {
					workNo: "",
					projectName: "",
					projectAddress: "",
					projectDetailedAddress: "",
					projectEntrust: "",
					projectDesignCompany: "",
					projectConstructionCompany: "",
					projectBeginTime: "",
					projectFinishTime: "",
					projectKind: "",
					contractCompany: ""
				}
			}
		},
		mounted() {
			this.project = common.getProject();
		},
		created() {
		},
		methods: {
			goBack() {
				this.$router.push({
					name: 'projectList'
				});
			},
			goPhoto(){
				this.$router.push({name:'photoList'});
			}
		}
	}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>
